<template>
  <div class="main-bg">
    <b-row class="custom-row">
      <a href="/">
        <img class="custom-logo" src="../../assets/income.svg" width="120"/>
      </a>
      <b-col align-self="center" md="6" sm="12" >
        <div class="custom-form">
              <b-form-group
                  id="input-group-1"
                  label-for="input-1"
                  content-cols-sm
                  content-cols-lg="6"
              >
                <b-button
                  variant="outline-dark"
                  class="name-field custom-spacing"
                  to="/login"><b-icon-arrow-left/></b-button>
                <h1 class="mb-2 reset-label" ><strong>Reset Password</strong></h1>
              </b-form-group>
              <b-form v-on:submit.prevent="reset">
                <b-form-group

                    id="input-group-1"
                    label-for="input-1"
                    content-cols-sm
                    content-cols-lg="6"
                >
                  <b-form-input
                      class="name-field custom-spacing"
                      id="input-username"
                      v-model="authData.username"
                      type="email"
                      :state="validationUsernameState"
                      placeholder="Email"
                      required
                  ></b-form-input>
                  <b-form-invalid-feedback
                      class="custom-spacing"
                  >
                    {{validationError.username}}
                  </b-form-invalid-feedback>
                  <b-button
                      pill
                            block
                            variant="primary"
                            content-cols-sm
                            content-cols-lg="5"
                      type="submit"
                  >Submit</b-button>

                </b-form-group>
              </b-form>
        </div>
      </b-col>
      <b-col md="6" sm="0" class="disable-sm right-col">
        <right-column/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import RightColumn from '../../components/auth/RightColumn'

export default {
  components: {RightColumn},

  data()
  {
    return {
      authData: {
        username: '',
        password: ''
      },
      validationUsernameState: null,
      validationPasswordState: null,
      validationError: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    reset()
    {
      this.danger = false
      axios.post('/auth0-reset-password', this.authData).then((response) =>
      {
        if (response.data.success === true)
        {
          window.location.href = '/login'
        }
        else
        {
          this.validationError = response.data.error
          this.validationUsernameState = this.validationError.username.length === 0
          this.validationPasswordState = this.validationError.password.length === 0
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.custom-logo {
  position: absolute; top: 2rem; left: 5rem;
}

.disable-sm {
  display: flex; justify-content: center;
}

@media (max-width: 575px) {
  .custom-logo {
    position: initial;
    margin-left: 1rem!important;
    margin-top: 1rem!important;
    margin-bottom: 2rem!important;
  }
  .disable-sm {
    display: none;
  }
}

.custom-spacing {
  margin-bottom: 10px!important;
}

.icon {
  position: absolute;
  left: 10px;
  min-width: 50px;
  margin-top: 2px;
  text-align: left;
}

.apple-color {
  fill: #6c757d;
}
.reset-label {
  font-size: 48px; font-family: Open Sans!important;
  line-height: 50px;
}

.custom-spacing:hover .icon .apple-color {
  fill: white;
}
.custom-row {
  margin: 0;
}

.custom-form {
  margin-right: 3vw!important;
}

.right-col {
  background-color: rgba(7,29,45, 1);
  padding: 0;
}

.main-bg {
  background-color: #F5FBFF;
}

</style>
